var _circle, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFundEllipseTop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 263,
    height: 263,
    viewBox: "0 0 263 263",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 163.02,
    cy: 100.02,
    r: 162.499,
    transform: "rotate(75 163.02 100.02)",
    fill: "url(#paint0_linear_844_252)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_844_252",
    x1: 37.9717,
    y1: -80.8873,
    x2: 203.769,
    y2: 280.084,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.436568,
    stopColor: "#131519",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.629417,
    stopColor: "#251463",
    stopOpacity: 0.565526
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7967,
    stopColor: "#33139C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.901332,
    stopColor: "#621F97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#93357B"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFundEllipseTop);
export default __webpack_public_path__ + "static/media/fund-ellipse-top.ebe049a4874a208b22c3c9026121bbf4.svg";
export { ForwardRef as ReactComponent };